import { z } from 'zod';
export var VideoCallCompletedSchema = z.object({
    first_name: z.string(),
    last_name: z.string(),
    email: z.string(),
    contact_number: z.string(),
    preferred_contact_method: z.string(),
    source: z.string(),
});
